import React from 'react';
import PropTypes from 'prop-types';
import { reduxForm, propTypes, Field } from 'redux-form';
import { Link } from 'react-router-dom';
//
import { TextField, Button } from 'components';
import { ROUTES } from 'config/constants';
import { FormTile } from 'components/FormTile';
import { validate } from './validate';

@reduxForm({
  form: 'forgotPasswordForm',
  validate,
})
export class ForgotPasswordForm extends React.PureComponent {
  static propTypes = {
    ...propTypes,
    isFormProcessed: PropTypes.bool,
  };

  render() {
    const { handleSubmit, error, submitFailed, isFormProcessed } = this.props;

    return (
      <form
        onSubmit={handleSubmit}
        className="form-tile-with-image "
        data-testid="forgot-password-form"
      >
        <FormTile isLoaderShow={isFormProcessed}>
          <FormTile.Header>
            <div className="form-description-logo">
              <img
                className="form-description-logo__img"
                src="/assets/images/logo/description-logo@2x.png"
                alt="Anova logo"
              />
            </div>
          </FormTile.Header>
          <FormTile.Body>
            <h2 className="mt-25">Password recovery</h2>
            <div className="mt-1 form-fields__description">
              Enter your email to receive your password reset instructions.
            </div>

            <Field
              label="Email:"
              name="email"
              isBackgroundErrorDisplay={false}
              component={TextField}
              fieldClassName="mt-14"
              props={{ testId: 'recovery-email-input' }}
            />
          </FormTile.Body>
          <FormTile.Footer>
            {error && submitFailed && (
              <div
                className="form-tile-footer__error"
                data-testid="error-message"
              >
                {error}
              </div>
            )}
            <div className="form-tile-footer__panel">
              <Link to={ROUTES.SIGN_UP} className="text-decoration-none">
                <Button
                  className="_simple-red"
                  type="button"
                  dataTestId="sign-up-button"
                >
                  Sign Up
                </Button>
              </Link>
              <Button
                className="_red"
                type="submit"
                dataTestId="send-reset-button"
              >
                Submit
              </Button>
            </div>
          </FormTile.Footer>
        </FormTile>
      </form>
    );
  }
}
